<div class="etl-monitor-container">
  <!-- Header Section -->
  <div class="monitor-header">
    <div class="header-title">
      <h1>ETL Process Monitor</h1>
      <p class="subtitle">Monitor the progress of compressed file uploads and record processing</p>
    </div>
  </div>

  <!-- File Processing Queue -->
  @if (viewModel$ | async; as viewModel) {
    <div class="file-queue-section">
      <h2 class="section-title">File Processing Queue</h2>
      <div class="file-list">
        @if (viewModel.inQueueFiles.length) {
          @for (file of viewModel.inQueueFiles; track file) {
            <div class="file-item">
              <!-- File Header -->
              <div class="file-header">
                <div class="file-icon-name">
                  <i class="icon-file-zip"></i>
                  <div class="file-info">
                    <h3 class="file-name">{{ file.FileName }}</h3>
                    <p class="file-time">Uploaded {{ file.UploadedOn | date: 'short' }} - Waiting in
                      queue
                    </p>
                  </div>
                </div>
                <div class="file-status-badge" class="status-queued">
                  <i class="icon-status"></i>
                  Queued
                </div>
              </div>
              <!-- File Body -->
              @if (file.status === 'Processing' || file.status === 'Completed' || file.status === 'Failed') {
                <div class="file-body"
                  >
                  <p class="processing-info">{{ file.processingRecords }}</p>
                  <div class="progress-bar-container small">
                    <div class="progress-bar" [style.width.%]="file.progress"></div>
                  </div>
                  <div class="progress-percent">{{ file.progress }}%</div>
                  <!-- Category Tags -->
                  @if (file.categories.length > 0) {
                    <div class="category-tags">
                      @for (cat of file.categories; track cat) {
                        <span class="category-tag"
                          [class]="'category-' + cat.status">
                          <i class="icon-category"></i>
                          {{ cat.name }}
                        </span>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        } @else {
          <div class="progress-card">
            <p class="no-items-message">No files are currently in the processing queue.</p>
          </div>
        }
      </div>
    </div>
    <div class="file-queue-section">
      <h2 class="section-title">Completed/InProgress Files</h2>
      @for (processedItem of viewModel.processedFiles; track processedItem) {
        <div class="progress-card">
          <div class="progress-header">
            <div class="progress-info">
              <!-- <h2 class="section-title">Overall Progress</h2> -->
              <p class="file-name">{{ processedItem.FileName }}</p>
              <p class="file-time">{{ processedItem.StartedAt | date: 'short' }}</p>
            </div>
            <div class="progress-header-right">
              <div class="in-progress-badge">
                <i class="icon-circle"></i>
                {{ processedItem.Status }}
              </div>
              <div class="records-processed">
                <span class="record-count">{{ getCompletedItems(processedItem) }} / {{
                  getTotalRecords(processedItem)
                }}</span>
                <span class="record-label">Records processed</span>
              </div>
            </div>
          </div>
          <div class="progress-percentage">
            {{ getProgressPercentage(processedItem) }}% Complete
          </div>
          <div class="progress-bar-container">
            <div class="progress-bar" [style.width.%]="getProgressPercentage(processedItem)"></div>
          </div>
          <!-- Progress Stats Grid -->
          <div class="progress-stats">
            @for (item of processedItem.ProcessingItems; track item) {
              <div class="stat-item">
                <span class="stat-label">{{ item.Name }}</span>
                <span class="stat-value">{{ item.Processed }}</span>
                @if (item.Failed > 0) {
                  <span class="stat-failed">{{ item.Failed }} Failed</span>
                }
                <span class="stat-status">{{ item.Status }}</span>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</div>